module.exports = __webpack_public_path__ + "static/media/gb.efa718ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/gb.svg
// module id = 1447
// module chunks = 0